import { FC, SVGProps } from 'react';

const FeatureRequestIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#fff',
  size = 20,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.85135 12.9847C5.89811 12.1609 4.52783 10.2263 4.52783 7.96739C4.52783 4.5701 7.62918 1.90334 11.1473 2.61604C13.2303 3.04253 14.9152 4.71767 15.3498 6.80064C15.9148 9.5225 14.4335 12.0312 12.1559 12.9936L12.1535 14.0663C12.1519 14.7563 11.5924 15.315 10.9033 15.315H9.09917C8.40676 15.315 7.84648 14.7523 7.84811 14.0607L7.85135 12.9847Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M8.92578 17.5H11.072" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M12.1561 12.9949L10.1157 12.9951"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default FeatureRequestIcon;
